var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('BaseInput',{attrs:{"label":_vm.label,"hints":_vm.hints}},[_c('input',{attrs:{"type":_vm.type,"placeholder":_vm.placeholder,"required":_vm.required},domProps:{"value":_vm.value},on:{"input":_vm.handleInput}})])
}
var staticRenderFns = []

export { render, staticRenderFns }